import { Pipe, PipeTransform } from '@angular/core';
import { numberSeparator } from '../../utils/number-separator';
import { round } from '../../utils/round';

@Pipe({ name: 'indianRoundCurrency', standalone: false })
export class IndianRoundCurrency implements PipeTransform {
  public transform(
    value: number | null | undefined,
    pointValue: number = 2
  ): string {
    value = !value ? 0 : value;
    if (!isNaN(value)) {
      const currencySymbol = '₹';
      return (
        currencySymbol +
        numberSeparator(parseFloat(round(value, pointValue)).toFixed())
      );
    }
    return '';
  }
}
